import { STATE_INFO_BY_FIPS } from "./data/FIPS"
import { COUNTY_NAME_BY_FIPS } from "./data/CountyNameByFIPS"
/**
 * Translate FIPS code into the name of the state and county
 * @param fips
 */
// TODO: Write a test for this
export function fipsToStateAndCounty(fips: FIPSCode): {
    usState: string
    usCounty?: string
} {
    const stateFIPS = getStateFIPS(fips)
    const usState = STATE_INFO_BY_FIPS[stateFIPS].name
    if (fips.length < 5) {
        return { usState }
    }
    const usCounty = COUNTY_NAME_BY_FIPS[parseInt(fips)]
    return { usState, usCounty }
}

/**
 * Get the state portion of a FIPS code
 * @param fips
 */
export function getStateFIPS(fips: FIPSCode): FIPSCode {
    return fips.substring(0, 2)
}

export function ensureValidFIPS(fips: FIPSCode): void {
    if (fips === undefined) {
        const err = new Error("fips was undefined")
        console.error({ err, fips })
        throw err
    }
    if (fips === null) {
        const err = new Error("fips was null")
        console.error({ err, fips })
        throw err
    }
    if (typeof fips !== "string") {
        const err = new Error("typeof fips was not 'string'")
        console.error({ err, fips, type: typeof fips })
        throw err
    }
    if (fips.length !== 2 && fips.length !== 5) {
        const err = new Error("invalid FIPS length")
        console.error({ err, fips })
        throw err
    }
}
